import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';

import { UiModule } from '../../shared/ui/ui.module';
import { AuthRoutingModule } from './auth-routing';

import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MAT_SELECT_CONFIG, MatSelectModule } from '@angular/material/select';
import { WebLandingPageComponent } from './web-landing-page/web-landing-page.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgbNavModule, NgbDropdownModule, NgbTooltipModule, NgbPaginationModule, NgbDatepickerModule, NgbDateAdapter, NgbDateParserFormatter, NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { NewLandingWebComponent } from './new-landing-web/new-landing-web.component';
import { QrCodeModule } from 'ng-qrcode';
import { DeeplinkMBComponent } from './deeplink-mb/deeplink-mb.component';

@NgModule({
  declarations: [WebLandingPageComponent , NewLandingWebComponent , DeeplinkMBComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbAlertModule,
    UiModule,
    AuthRoutingModule,
    TranslateModule,
    FormsModule,
    ChartsModule,
    NgSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatExpansionModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbPaginationModule,
    NgbDatepickerModule,
    NgSelectModule,
    QrCodeModule
  ],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'customClass' }
    }
  ],
})
export class AuthModule { }
